import React, {Component} from "react"
import PropTypes from "prop-types"

import Button from "@irati/ui/src/Button"
import id from "@irati/utils/id"
import {FormattedMessage} from "@irati/utils/lang"

class NextStep extends Component {
  static propTypes = {
    onClick: PropTypes.func.isRequired
  }

  static defaultProps = {
    id: "nextStep"
  }

  render() {
    const {onClick} = this.props
    return (
      <Button primary id={id("button", this.props)} onClick={onClick}>
        <FormattedMessage id="recognition.onboarding.buttons.next" />
      </Button>
    )
  }
}

export default NextStep
